/**
 * Module d'affichage des branches (entrepôts)
 *
 * @export
 * @class Branches
 */
export class Branches {
    listeBranches;
    brancheActive;
    /**
     * Créer une instance du gestionnaire de branches.
     *
     * @memberof Branches
     */
    constructor() {
        //console.log('Dans constructeur Branches');
        // Mettre la main sur les éléments du DOM
        this.listeBranches = document.getElementById('liste-branches');
        this.brancheActive = document.getElementById(this.listeBranches.value);
        // Assigner les écouteurs (listeners)
        this.ajouterListeners();
    }
    /**
     * Ajouter les listeners sur la liste de branches
     *
     * @private
     * @memberof Branches
     */
    ajouterListeners() {
        //console.log('Dans ajouterListeners()');
        this.listeBranches.addEventListener("change", () => {
            // Cacher la branche active
            //console.log("Cacher la branche: " + this.brancheActive.id);
            this.brancheActive.style.display = ''; // Revenir au style de base (caché)
            // Afficher la branche sélectionnée
            this.brancheActive = document.getElementById(this.listeBranches.value);
            //console.log("Afficher la branche: " + this.brancheActive.id);
            this.brancheActive.style.display = 'block';
            // «Preloader» l'image avant de l'appliquer en background-image.
            //const backgroundImage = new Image();
            //backgroundImage.addEventListener("load", () => { blocEntrepots.style.backgroundImage = `url(${backgroundImage.src})`; });
            //backgroundImage.src = `https://maps.googleapis.com/maps/api/staticmap?key=AIzaSyBDzC9h5bzcw8UzBd3J5vJI6VEbMjpxoNw&markers=size:tiny|${entrepotActif.getAttribute("data-coordonnees")}&zoom=10&size=640x640&scale=2`;
        });
    }
}
